'use client';

import { AppProgressProvider } from '@bprogress/next';

export default function ProgressProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AppProgressProvider
      color="var(--primary)"
      height="4px"
      options={{ showSpinner: false }}
      shallowRouting
    >
      {children}
    </AppProgressProvider>
  );
}
